import crypto from 'crypto-js'

const cipher = 'djblaz'

export const encrypt = data => {
  return crypto.AES.encrypt(data, cipher).toString()
}

export const decrypt = data => {
  try {
    return crypto.AES.decrypt(data, cipher).toString(crypto.enc.Utf8)
  }
  catch (error) {
    return '{"token": ""}'
  }
}
